@for (param of parameters; track param.code; let i = $index) {
    @if (
        param.kind !== LogicStepParameterType.LogicStep &&
        isParameterVisible(param)
    ) {
        <wdx-form-field
            [label]="param.name?.key | translateTokenisedString"
            [guidanceText]="param.description?.key | translateTokenisedString"
            [isRequired]="param.isRequired"
            [labelForId]="param.code"
            [formGroup]="formGroup"
            class="d-block mb-4"
        >
            @if (
                PrimitiveKinds.includes(param.kind) &&
                !(param.options || param.isArray)
            ) {
                <clmi-workflow-designer-parameter-input
                    [parameter]="param"
                    [formGroup]="formGroup"
                    [componentProvider]="componentProvider"
                />
            } @else if (SegmentedKinds.includes(param.kind)) {
                <clmi-workflow-designer-parameter-segmented
                    [parameter]="param"
                    [formGroup]="formGroup.get(param.code)"
                    [componentProvider]="componentProvider"
                />
            } @else if (LookupKinds.includes(param.kind) || param.options) {
                <clmi-workflow-designer-parameter-input
                    [parameter]="param"
                    [formGroup]="formGroup"
                    [componentProvider]="componentProvider"
                />
            } @else if (param.kind === LogicStepParameterType.Object) {
                @if (formGroup.get(param.code); as formArray) {
                    @for (
                        group of formArray.controls;
                        track group.get('id')?.value;
                        let i = $index;
                        let first = $first
                    ) {
                        <div class="border p-3 mb-2 rounded">
                            <clmi-workflow-designer-parameter-group
                                [parameters]="param.properties"
                                [formGroup]="group"
                                [addCollectionItem]="addCollectionItem"
                                [removeCollectionItem]="removeCollectionItem"
                                [componentProvider]="componentProvider"
                            />

                            @if (param.isArray) {
                                <div class="mt-2 text-end">
                                    @if (first) {
                                        <button
                                            wdxIconButton
                                            type="button"
                                            (click)="addCollectionItem(param)"
                                        >
                                            <wdx-icon icon="plus"></wdx-icon>
                                        </button>
                                    } @else {
                                        <button
                                            wdxIconButton
                                            type="button"
                                            (click)="
                                                removeCollectionItem(
                                                    param.code,
                                                    i
                                                )
                                            "
                                        >
                                            <wdx-icon icon="minus"></wdx-icon>
                                        </button>
                                    }
                                </div>
                            }
                        </div>
                    }
                }
            } @else if (param.isArray) {
                @if (formGroup.get(param.code); as formArray) {
                    <p>
                        @for (
                            group of formArray.controls;
                            track group.get('id')?.value;
                            let i = $index;
                            let first = $first
                        ) {
                            <div class="d-flex align-items-center gap-2">
                                <clmi-workflow-designer-parameter-input
                                    [parameter]="param"
                                    [formGroup]="group"
                                    class="flex-grow-1"
                                />
                                @if (first) {
                                    <button
                                        wdxIconButton
                                        type="button"
                                        (click)="addCollectionItem(param)"
                                    >
                                        <wdx-icon icon="plus"></wdx-icon>
                                    </button>
                                } @else {
                                    <button
                                        wdxIconButton
                                        type="button"
                                        (click)="
                                            removeCollectionItem(param.code, i)
                                        "
                                    >
                                        <wdx-icon icon="minus"></wdx-icon>
                                    </button>
                                }
                            </div>
                        }
                    </p>
                }
            } @else {
                <p class="text-muted mb-0">
                    Unsupported parameter kind: {{ param.kind }}
                </p>
            }
        </wdx-form-field>
    }
}
